import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupGlobalErrorTracking } from './utils/errorTracker';

// Redirect non-hash URLs to hash URLs BEFORE React Router processes them
const pathname = window.location.pathname;
const search = window.location.search;
const hash = window.location.hash;

if (pathname !== '/' && !hash) {
  window.location.replace(`/#${pathname}${search}`);
}

setupGlobalErrorTracking();

// Setup QueryClient dengan cache disabled untuk dashboard data
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
